import { useEffect, useState } from "react";

// Formato italiano: punto = migliaia, virgola = decimali ("250.000" → 250000, "1.234,5" → 1234.5)
export const parseIt = (v) => {
  if (v === null || v === undefined || v === "") return null;
  if (typeof v === "number") return Number.isFinite(v) ? v : null;
  let s = String(v).replace(/[€\s]/g, "");
  if (!s) return null;
  if (s.includes(",")) s = s.replace(/\./g, "").replace(",", ".");
  else if (/^-?\d{1,3}(\.\d{3})+$/.test(s)) s = s.replace(/\./g, "");
  const n = Number(s);
  return Number.isFinite(n) ? n : null;
};

export const fmtIt = (n, dec = 2) => {
  const [i, d] = Math.abs(Number(n)).toFixed(dec).split(".");
  return `${Number(n) < 0 ? "-" : ""}${i.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}${d ? `,${d}` : ""}`;
};
const toText = (v) => (v === null || v === undefined || v === "" ? "" : fmtIt(Number(v), Number(v) % 1 ? 2 : 0));

export function EuroInput({ value, onChange, testid, className, placeholder, disabled }) {
  const [text, setText] = useState(toText(value));
  useEffect(() => {
    if (value === undefined) return;
    const cur = parseIt(text);
    const nv = value === "" || value === undefined ? null : Number(value);
    if (cur !== nv) setText(toText(value));
  }, [value]); // eslint-disable-line
  const n = parseIt(text);
  return (
    <>
      <input data-testid={testid} type="text" inputMode="decimal" value={text} disabled={disabled} placeholder={placeholder || "es. 250.000"} className={className}
        onChange={(e) => { setText(e.target.value); const p = parseIt(e.target.value); onChange({ target: { value: p === null ? "" : p } }); }} />
      {text !== "" && (
        <p data-testid={testid ? `${testid}-anteprima` : undefined} className={`mt-1 text-[11px] font-medium ${n === null ? "text-red-600" : "text-[var(--muted)]"}`}>
          {n === null ? "Importo non valido" : `= ${fmtIt(n)} €`}
        </p>
      )}
    </>
  );
}
